import React, { useRef, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import ToastContext from '../contexts/ToastContext';
import { FiUser, FiHome, FiMail, FiCalendar, FiUsers, FiGlobe, FiPhone, FiLock, FiCheck } from 'react-icons/fi';

const countries = [
  "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda", "Argentina", "Armenia", "Australia", "Austria",
  "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bhutan",
  "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Cabo Verde", "Cambodia",
  "Cameroon", "Canada", "Central African Republic", "Chad", "Chile", "China", "Colombia", "Comoros", "Congo", "Costa Rica",
  "Croatia", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt",
  "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", "Ethiopia", "Fiji", "Finland", "France", "Gabon",
  "Gambia", "Georgia", "Germany", "Ghana", "Greece", "Grenada", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana",
  "Haiti", "Honduras", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel",
  "Italy", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Kuwait", "Kyrgyzstan", "Laos",
  "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Madagascar", "Malawi",
  "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Mauritania", "Mauritius", "Mexico", "Micronesia", "Moldova",
  "Monaco", "Mongolia", "Montenegro", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands",
  "New Zealand", "Nicaragua", "Niger", "Nigeria", "North Korea", "North Macedonia", "Norway", "Oman", "Pakistan", "Palau",
  "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Qatar", "Romania", "Russia",
  "Rwanda", "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia",
  "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Korea", "South Sudan",
  "Spain", "Sri Lanka", "Sudan", "Suriname", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania",
  "Thailand", "Timor-Leste", "Togo", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Tuvalu", "Uganda",
  "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "Uruguay", "Uzbekistan", "Vanuatu", "Vatican City", "Venezuela", "Vietnam",
  "Yemen", "Zambia", "Zimbabwe"
];

const countryFlags = {
  "Afghanistan": "🇦🇫", "Albania": "🇦🇱", "Algeria": "🇩🇿", "Andorra": "🇦🇩", "Angola": "🇦🇴", "Antigua and Barbuda": "🇦🇬", "Argentina": "🇦🇷", "Armenia": "🇦🇲", "Australia": "🇦🇺", "Austria": "🇦🇹",
  "Azerbaijan": "🇦🇿", "Bahamas": "🇧🇸", "Bahrain": "🇧🇭", "Bangladesh": "🇧🇩", "Barbados": "🇧🇧", "Belarus": "🇧🇾", "Belgium": "🇧🇪", "Belize": "🇧🇿", "Benin": "🇧🇯", "Bhutan": "🇧🇹",
  "Bolivia": "🇧🇴", "Bosnia and Herzegovina": "🇧🇦", "Botswana": "🇧🇼", "Brazil": "🇧🇷", "Brunei": "🇧🇳", "Bulgaria": "🇧🇬", "Burkina Faso": "🇧🇫", "Burundi": "🇧🇮", "Cabo Verde": "🇨🇻", "Cambodia": "🇰🇭",
  "Cameroon": "🇨🇲", "Canada": "🇨🇦", "Central African Republic": "🇨🇫", "Chad": "🇹🇩", "Chile": "🇨🇱", "China": "🇨🇳", "Colombia": "🇨🇴", "Comoros": "🇰🇲", "Congo": "🇨🇬", "Costa Rica": "🇨🇷",
  "Croatia": "🇭🇷", "Cuba": "🇨🇺", "Cyprus": "🇨🇾", "Czech Republic": "🇨🇿", "Denmark": "🇩🇰", "Djibouti": "🇩🇯", "Dominica": "🇩🇲", "Dominican Republic": "🇩🇴", "Ecuador": "🇪🇨", "Egypt": "🇪🇬",
  "El Salvador": "🇸🇻", "Equatorial Guinea": "🇬🇶", "Eritrea": "🇪🇷", "Estonia": "🇪🇪", "Eswatini": "🇸🇿", "Ethiopia": "🇪🇹", "Fiji": "🇫🇯", "Finland": "🇫🇮", "France": "🇫🇷", "Gabon": "🇬🇦",
  "Gambia": "🇬🇲", "Georgia": "🇬🇪", "Germany": "🇩🇪", "Ghana": "🇬🇭", "Greece": "🇬🇷", "Grenada": "🇬🇩", "Guatemala": "🇬🇹", "Guinea": "🇬🇳", "Guinea-Bissau": "🇬🇼", "Guyana": "🇬🇾",
  "Haiti": "🇭🇹", "Honduras": "🇭🇳", "Hungary": "🇭🇺", "Iceland": "🇮🇸", "India": "🇮🇳", "Indonesia": "🇮🇩", "Iran": "🇮🇷", "Iraq": "🇮🇶", "Ireland": "🇮🇪", "Israel": "🇮🇱",
  "Italy": "🇮🇹", "Jamaica": "🇯🇲", "Japan": "🇯🇵", "Jordan": "🇯🇴", "Kazakhstan": "🇰🇿", "Kenya": "🇰🇪", "Kiribati": "🇰🇮", "Kuwait": "🇰🇼", "Kyrgyzstan": "🇰🇬", "Laos": "🇱🇦",
  "Latvia": "🇱🇻", "Lebanon": "🇱🇧", "Lesotho": "🇱🇸", "Liberia": "🇱🇷", "Libya": "🇱🇾", "Liechtenstein": "🇱🇮", "Lithuania": "🇱🇹", "Luxembourg": "🇱🇺", "Madagascar": "🇲🇬", "Malawi": "🇲🇼",
  "Malaysia": "🇲🇾", "Maldives": "🇲🇻", "Mali": "🇲🇱", "Malta": "🇲🇹", "Marshall Islands": "🇲🇭", "Mauritania": "🇲🇷", "Mauritius": "🇲🇺", "Mexico": "🇲🇽", "Micronesia": "🇫🇲", "Moldova": "🇲🇩",
  "Monaco": "🇲🇨", "Mongolia": "🇲🇳", "Montenegro": "🇲🇪", "Morocco": "🇲🇦", "Mozambique": "🇲🇿", "Myanmar": "🇲🇲", "Namibia": "🇳🇦", "Nauru": "🇳🇷", "Nepal": "🇳🇵", "Netherlands": "🇳🇱",
  "New Zealand": "🇳🇿", "Nicaragua": "🇳🇮", "Niger": "🇳🇪", "Nigeria": "🇳🇬", "North Korea": "🇰🇵", "North Macedonia": "🇲🇰", "Norway": "🇳🇴", "Oman": "🇴🇲", "Pakistan": "🇵🇰", "Palau": "🇵🇼",
  "Panama": "🇵🇦", "Papua New Guinea": "🇵🇬", "Paraguay": "🇵🇾", "Peru": "🇵🇪", "Philippines": "🇵🇭", "Poland": "🇵🇱", "Portugal": "🇵🇹", "Qatar": "🇶🇦", "Romania": "🇷🇴", "Russia": "🇷🇺",
  "Rwanda": "🇷🇼", "Saint Kitts and Nevis": "🇰🇳", "Saint Lucia": "🇱🇨", "Saint Vincent and the Grenadines": "🇻🇨", "Samoa": "🇼🇸", "San Marino": "🇸🇲", "Sao Tome and Principe": "🇸🇹", "Saudi Arabia": "🇸🇦", "Senegal": "🇸🇳", "Serbia": "🇷🇸",
  "Seychelles": "🇸🇨", "Sierra Leone": "🇸🇱", "Singapore": "🇸🇬", "Slovakia": "🇸🇰", "Slovenia": "🇸🇮", "Solomon Islands": "🇸🇧", "Somalia": "🇸🇴", "South Africa": "🇿🇦", "South Korea": "🇰🇷", "South Sudan": "🇸🇸",
  "Spain": "🇪🇸", "Sri Lanka": "🇱🇰", "Sudan": "🇸🇩", "Suriname": "🇸🇷", "Sweden": "🇸🇪", "Switzerland": "🇨🇭", "Syria": "🇸🇾", "Taiwan": "🇹🇼", "Tajikistan": "🇹🇯", "Tanzania": "🇹🇿",
  "Thailand": "🇹🇭", "Timor-Leste": "🇹🇱", "Togo": "🇹🇬", "Tonga": "🇹🇴", "Trinidad and Tobago": "🇹🇹", "Tunisia": "🇹🇳", "Turkey": "🇹🇷", "Turkmenistan": "🇹🇲", "Tuvalu": "🇹🇻", "Uganda": "🇺🇬",
  "Ukraine": "🇺🇦", "United Arab Emirates": "🇦🇪", "United Kingdom": "🇬🇧", "United States": "🇺🇸", "Uruguay": "🇺🇾", "Uzbekistan": "🇺🇿", "Vanuatu": "🇻🇺", "Vatican City": "🇻🇦", "Venezuela": "🇻🇪", "Vietnam": "🇻🇳",
  "Yemen": "🇾🇪", "Zambia": "🇿🇲", "Zimbabwe": "🇿🇼"
};

const STEPS = [
  { key: 'firstName', label: 'Prénom', question: 'Quel est votre prénom ?' },
  { key: 'lastName', label: 'Nom', question: 'Quel est votre nom ?' },
  { key: 'email', label: 'Email', question: 'Quel est votre adresse email ?' },
  { key: 'dateOfBirth', label: 'Date de naissance', question: 'Quelle est votre date de naissance ?' },
  { key: 'gender', label: 'Genre', question: 'Quel est votre genre ?' },
  { key: 'country', label: 'Pays', question: 'De quel pays êtes-vous ?' },
  { key: 'phone', label: 'Téléphone', question: 'Quel est votre numéro de téléphone ?' },
  { key: 'password', label: 'Mot de passe', question: 'Choisissez un mot de passe' },
  { key: 'confirmPassword', label: 'Confirmer', question: 'Confirmez votre mot de passe' },
];

export default function Register() {
  const emailRef = useRef();
  const firstNameRef = useRef();
  const lastNameRef = useRef();
  const dateOfBirthRef = useRef();
  const countryRef = useRef();
  const phoneRef = useRef();
  const [gender, setGender] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [dateOfBirth, setDateOfBirth] = useState('');
  const [country, setCountry] = useState('');
  const [phone, setPhone] = useState('');
  const { signup } = useAuth();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState('');
  const navigate = useNavigate();
  const toast = useContext(ToastContext);

  const validateStep = (step) => {
    const newErrors = {};
    
    switch (step) {
      case 'firstName':
        if (!firstName.trim()) newErrors.firstName = 'Le prénom est requis';
        break;
      case 'lastName':
        if (!lastName.trim()) newErrors.lastName = 'Le nom est requis';
        break;
      case 'email':
        if (!email.trim()) newErrors.email = 'L\'email est requis';
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) newErrors.email = 'Email invalide';
        break;
      case 'dateOfBirth':
        if (!dateOfBirth) newErrors.dateOfBirth = 'La date de naissance est requise';
        break;
      case 'gender':
        if (!gender) newErrors.gender = 'Le genre est requis';
        break;
      case 'country':
        if (!country) newErrors.country = 'Le pays est requis';
        break;
      case 'phone':
        if (!phone.trim()) newErrors.phone = 'Le téléphone est requis';
        break;
      case 'password':
        if (!password) newErrors.password = 'Le mot de passe est requis';
        else if (password.length < 6) newErrors.password = 'Min 6 caractères';
        break;
      case 'confirmPassword':
        if (!confirmPassword) newErrors.confirmPassword = 'Confirmez le mot de passe';
        else if (password !== confirmPassword) newErrors.confirmPassword = 'Les mots de passe ne correspondent pas';
        break;
      default:
        break;
    }
    
    return newErrors;
  };

  const canProceedToNext = () => {
    const currentKey = STEPS[currentStep].key;
    const stepErrors = validateStep(currentKey);
    
    if (Object.keys(stepErrors).length > 0) {
      setErrors(stepErrors);
      return false;
    }
    
    setErrors({});
    return true;
  };

  const handleNext = () => {
    if (canProceedToNext()) {
      if (currentStep < STEPS.length - 1) {
        setCurrentStep(currentStep + 1);
      } else {
        setCurrentStep(STEPS.length); // Aller à la page récapitulatif
      }
    }
  };

  const handlePrevious = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    
    try {
      const response = await signup(email, password, `${firstName} ${lastName}`, firstName, lastName, dateOfBirth, gender, country, phone);
      if (toast && toast.success) toast.success('Inscription réussie');
      
      // Afficher le message de succès avec les instructions de vérification
      setSuccessMessage('Un email de vérification a été envoyé à votre adresse email. Veuillez vérifier votre boîte de réception et cliquer sur le lien pour activer votre compte.');
      
      setTimeout(() => {
        navigate('/verify-email');
      }, 3000);
    } catch (err) {
      let friendly = 'Erreur inconnue';
      if (err && err.message === 'Failed to fetch') {
        friendly = "Impossible de contacter le serveur. Vérifiez la connexion réseau.";
      } else if (err && err.body) {
        if (Array.isArray(err.body.errors) && err.body.errors.length > 0) {
          friendly = err.body.errors.map(e => e.msg || e.param || JSON.stringify(e)).join('; ');
        } else if (err.body.message) {
          friendly = err.body.message;
        }
      } else if (err && err.message) {
        friendly = err.message;
      }
      setError(friendly);
      if (toast && toast.error) toast.error(friendly);
    }
    setLoading(false);
  }

  const getStepIcon = (key) => {
    const iconProps = { size: 18, style: { strokeWidth: 2.5 } };
    switch(key) {
      case 'firstName': return <FiUser {...iconProps} />;
      case 'lastName': return <FiHome {...iconProps} />;
      case 'email': return <FiMail {...iconProps} />;
      case 'dateOfBirth': return <FiCalendar {...iconProps} />;
      case 'gender': return <FiUsers {...iconProps} />;
      case 'country': return <FiGlobe {...iconProps} />;
      case 'phone': return <FiPhone {...iconProps} />;
      case 'password': return <FiLock {...iconProps} />;
      case 'confirmPassword': return <FiCheck {...iconProps} />;
      default: return null;
    }
  };

  const renderStepContent = () => {
    const step = STEPS[currentStep];
    
    switch (step.key) {
      case 'firstName':
        return (
          <div className="field">
            <div style={{display: 'flex', alignItems: 'center', gap: '0.75rem'}}>
              <div style={{fontSize: '1.8rem', color: 'var(--accent)', display: 'flex', alignItems: 'center'}}>
                <FiUser size={24} />
              </div>
              <input className="input" type="text" value={firstName} onChange={e => setFirstName(e.target.value)} placeholder="Votre prénom" autoFocus required style={{flex: 1}} />
            </div>
            {errors.firstName && <small style={{color: 'var(--error)'}}>⚠️ {errors.firstName}</small>}
          </div>
        );
      case 'lastName':
        return (
          <div className="field">
            <div style={{display: 'flex', alignItems: 'center', gap: '0.75rem'}}>
              <div style={{fontSize: '1.8rem', color: 'var(--accent)', display: 'flex', alignItems: 'center'}}>
                <FiHome size={24} />
              </div>
              <input className="input" type="text" value={lastName} onChange={e => setLastName(e.target.value)} placeholder="Votre nom" autoFocus required style={{flex: 1}} />
            </div>
            {errors.lastName && <small style={{color: 'var(--error)'}}>⚠️ {errors.lastName}</small>}
          </div>
        );
      case 'email':
        return (
          <div className="field">
            <input className="input" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="jean@example.com" autoFocus required />
            {errors.email && <small style={{color: 'var(--error)'}}>⚠️ {errors.email}</small>}
          </div>
        );
      case 'dateOfBirth':
        return (
          <div className="field">
            <input className="input" type="date" value={dateOfBirth} onChange={e => setDateOfBirth(e.target.value)} min="1960-01-01" max="2016-12-31" autoFocus required />
            {errors.dateOfBirth && <small style={{color: 'var(--error)'}}>⚠️ {errors.dateOfBirth}</small>}
          </div>
        );
      case 'gender':
        return (
          <div className="field">
            <select className="input" value={gender} onChange={e => setGender(e.target.value)} autoFocus required>
              <option value="">Sélectionnez</option>
              <option value="Homme">Homme</option>
              <option value="Femme">Femme</option>
              <option value="Autre">Autre</option>
              <option value="Préfère ne pas répondre">Préfère ne pas répondre</option>
            </select>
            {errors.gender && <small style={{color: 'var(--error)'}}>⚠️ {errors.gender}</small>}
          </div>
        );
      case 'country':
        return (
          <div className="field">
            <div style={{position: 'relative'}}>
              <input 
                className="input" 
                type="text"
                value={country}
                placeholder="Rechercher un pays..."
                readOnly
                onClick={() => {
                  const dropdown = document.getElementById('country-dropdown');
                  if (dropdown) dropdown.style.display = dropdown.style.display === 'none' ? 'block' : 'none';
                }}
                style={{cursor: 'pointer'}}
                autoFocus
              />
              <div 
                id="country-dropdown"
                style={{
                  position: 'absolute',
                  top: '100%',
                  left: 0,
                  right: 0,
                  background: 'var(--bg)',
                  border: '1px solid var(--border)',
                  borderRadius: '8px',
                  marginTop: '4px',
                  maxHeight: '300px',
                  overflowY: 'auto',
                  zIndex: 100,
                  display: 'none',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                }}
              >
                {countries.map(c => (
                  <div
                    key={c}
                    onClick={() => {
                      setCountry(c);
                      document.getElementById('country-dropdown').style.display = 'none';
                    }}
                    style={{
                      padding: '12px 16px',
                      cursor: 'pointer',
                      borderBottom: '1px solid var(--border)',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '12px',
                      fontSize: '1.2rem',
                      transition: 'background 0.2s ease'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.background = 'var(--bg-secondary)'}
                    onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                  >
                    <span style={{fontSize: '1.5rem'}}>{countryFlags[c]}</span>
                    <span>{c}</span>
                  </div>
                ))}
              </div>
            </div>
            {errors.country && <small style={{color: 'var(--error)'}}>⚠️ {errors.country}</small>}
          </div>
        );
      case 'phone':
        return (
          <div className="field">
            <input className="input" type="tel" value={phone} onChange={e => setPhone(e.target.value)} placeholder="+33 6 12 34 56 78" autoFocus required />
            {errors.phone && <small style={{color: 'var(--error)'}}>⚠️ {errors.phone}</small>}
          </div>
        );
      case 'password':
        return (
          <div className="field">
            <input className="input" type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Minimum 6 caractères" autoFocus required />
            {errors.password && <small style={{color: 'var(--error)'}}>⚠️ {errors.password}</small>}
          </div>
        );
      case 'confirmPassword':
        return (
          <div className="field">
            <input className="input" type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} placeholder="Confirmez" autoFocus required />
            {errors.confirmPassword && <small style={{color: 'var(--error)'}}>⚠️ {errors.confirmPassword}</small>}
            {confirmPassword && password === confirmPassword && <small style={{color: 'var(--success)', marginTop: '4px', display: 'block'}}>✅ Les mots de passe correspondent</small>}
          </div>
        );
      default:
        return null;
    }
  };

  const renderSummary = () => {
    return (
      <div style={{animation: 'fadeIn 0.3s ease-in'}}>
        <h3 style={{marginBottom: '20px', textAlign: 'center', fontSize: '1.3rem'}}>Vérifiez vos informations</h3>
        
        <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '20px'}}>
          <div className="card" style={{background: 'rgba(59, 130, 246, 0.05)', border: '1px solid rgba(59, 130, 246, 0.1)', padding: '12px'}}>
            <small className="muted" style={{fontSize: '0.85rem'}}>Prénom</small>
            <div style={{fontSize: '1.1rem', fontWeight: '500', marginTop: '4px'}}>{firstName}</div>
          </div>
          
          <div className="card" style={{background: 'rgba(59, 130, 246, 0.05)', border: '1px solid rgba(59, 130, 246, 0.1)', padding: '12px'}}>
            <small className="muted" style={{fontSize: '0.85rem'}}>Nom</small>
            <div style={{fontSize: '1.1rem', fontWeight: '500', marginTop: '4px'}}>{lastName}</div>
          </div>
          
          <div className="card" style={{background: 'rgba(59, 130, 246, 0.05)', border: '1px solid rgba(59, 130, 246, 0.1)', padding: '12px', gridColumn: '1 / -1'}}>
            <small className="muted" style={{fontSize: '0.85rem'}}>Email</small>
            <div style={{fontSize: '1.1rem', fontWeight: '500', marginTop: '4px'}}>{email}</div>
          </div>
          
          <div className="card" style={{background: 'rgba(59, 130, 246, 0.05)', border: '1px solid rgba(59, 130, 246, 0.1)', padding: '12px'}}>
            <small className="muted" style={{fontSize: '0.85rem'}}>Naissance</small>
            <div style={{fontSize: '1.1rem', fontWeight: '500', marginTop: '4px'}}>{new Date(dateOfBirth).toLocaleDateString('fr-FR')}</div>
          </div>
          
          <div className="card" style={{background: 'rgba(59, 130, 246, 0.05)', border: '1px solid rgba(59, 130, 246, 0.1)', padding: '12px'}}>
            <small className="muted" style={{fontSize: '0.85rem'}}>Genre</small>
            <div style={{fontSize: '1.1rem', fontWeight: '500', marginTop: '4px'}}>{gender}</div>
          </div>
          
          <div className="card" style={{background: 'rgba(59, 130, 246, 0.05)', border: '1px solid rgba(59, 130, 246, 0.1)', padding: '12px', gridColumn: '1 / -1'}}>
            <small className="muted" style={{fontSize: '0.85rem'}}>Pays</small>
            <div style={{fontSize: '1.1rem', fontWeight: '500', marginTop: '4px'}}>{country}</div>
          </div>
          
          <div className="card" style={{background: 'rgba(59, 130, 246, 0.05)', border: '1px solid rgba(59, 130, 246, 0.1)', padding: '12px', gridColumn: '1 / -1'}}>
            <small className="muted" style={{fontSize: '0.85rem'}}>Téléphone</small>
            <div style={{fontSize: '1.1rem', fontWeight: '500', marginTop: '4px'}}>{phone}</div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="container" style={{minHeight: 'auto', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px 12px', marginBottom: '80px'}}>
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes slideIn {
          from { opacity: 0; transform: translateX(10px); }
          to { opacity: 1; transform: translateX(0); }
        }
        .progress-bar-container {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 24px;
          position: relative;
        }
        .progress-step {
          flex: 1;
          text-align: center;
          position: relative;
          z-index: 2;
        }
        .progress-step-circle {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          background: var(--bg);
          color: var(--muted);
          border: 2px solid var(--border);
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 8px;
          font-weight: 600;
          font-size: 0.95rem;
          transition: all 0.22s ease;
          cursor: pointer;
        }
        .progress-step-circle.active {
          background: linear-gradient(90deg, var(--accent), var(--accent-2));
          color: white;
          border: none;
          box-shadow: 0 8px 24px rgba(60,78,90,0.12);
        }
        .progress-step-circle.completed {
          background: linear-gradient(90deg, var(--accent), var(--accent-2));
          color: white;
          border: none;
          box-shadow: 0 8px 24px rgba(60,78,90,0.12);
        }
        .progress-step-circle.active {
          background: var(--primary);
          color: white;
          border-color: var(--primary);
          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.08);
        }
        .progress-step-circle.completed {
          background: var(--primary);
          color: white;
          border-color: var(--primary);
        }
        .progress-step-label {
          font-size: 0.75rem;
          color: var(--text-secondary);
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          transition: color 0.3s ease;
        }
        .progress-step.active .progress-step-label {
          color: var(--primary);
          font-weight: 600;
        }
        .progress-step.completed .progress-step-label {
          color: var(--success);
        }
        /* Couleur uniforme pour tous les numéros - même que le bouton Continuer */
        .progress-step .progress-step-circle {
          border-color: var(--accent);
          color: var(--accent);
        }
        .progress-step .progress-step-circle.active,
        .progress-step .progress-step-circle.completed {
          background: linear-gradient(90deg, var(--accent), var(--accent-2));
          color: white;
          border: none;
          box-shadow: 0 8px 24px rgba(60,78,90,0.12);
        }
        .register-card {
          display: flex;
          flex-direction: column;
          gap: 24px;
        }
        .progress-bar-container {
          display: flex;
          align-items: center;
          justify-content: space-between;
          position: relative;
        }
        .progress-bar-container::before,
        .progress-bar-container::after {
          content: "";
          position: absolute;
          top: 50%;
          left: 0;
          right: 0;
          height: 2px;
          transform: translateY(-50%);
          pointer-events: none;
        }
        .progress-bar-container::before {
          background: var(--border);
          z-index: 1;
        }
        .progress-bar-container::after {
          background: var(--primary);
          width: var(--progress);
          transition: width 0.3s ease;
          z-index: 1;
        }
        .step-card {
          animation: slideIn 0.4s ease-out;
          min-height: auto;
          display: flex;
          flex-direction: column;
        }
        .button-group {
          display: flex;
          gap: 12px;
          margin-top: auto;
          padding-top: 20px;
          border-top: 1px solid var(--border);
        }
        .btn-nav {
          flex: 1;
          padding: 12px 16px;
          border: 2px solid var(--accent);
          background: transparent;
          color: var(--accent);
          border-radius: 8px;
          cursor: pointer;
          font-weight: 600;
          transition: all 0.2s ease;
          font-size: 1rem;
        }
        .btn-nav:hover:not(:disabled) {
          background: var(--accent);
          color: white;
          border-color: var(--accent);
        }
          .btn-nav:disabled {
            opacity: 0.85;
            cursor: not-allowed;
            filter: saturate(0.95) brightness(0.98);
          }
          .btn-next {
            background: var(--accent);
            color: white;
            border-color: var(--accent);
            box-shadow: 0 8px 30px rgba(60,78,90,0.14);
          }
          .btn-next:hover:not(:disabled) {
            filter: brightness(0.92);
          }
          .btn-next:disabled {
            /* keep visible color even when disabled (muted but colored) */
            opacity: 0.9;
            filter: grayscale(0.02) brightness(0.94);
          }
        @media (max-width: 640px) {
          .progress-step-label {
            font-size: 0.65rem;
          }
          .step-card {
            min-height: auto;
          }
          .button-group {
            padding-top: 20px;
          }
        }
      `}</style>

      <div className="card register-card" style={{width: '100%', maxWidth: '600px', animation: 'fadeIn 0.3s ease-in'}}>
        <h2 style={{margin: 0, textAlign: 'center'}}>Créer votre compte</h2>

        {error && (
          <div role="alert" className="card headerless" style={{
            background: 'rgba(239,68,68,0.04)',
            borderLeft: '4px solid var(--error)',
            marginBottom: '20px',
            animation: 'fadeIn 0.3s ease'
          }}>
            <div style={{color: 'var(--error)'}}>❌ {error}</div>
          </div>
        )}

        {successMessage && (
          <div role="alert" className="card headerless" style={{
            background: 'rgba(76, 175, 80, 0.04)',
            borderLeft: '4px solid #4CAF50',
            marginBottom: '20px',
            animation: 'fadeIn 0.3s ease'
          }}>
            <div style={{color: '#2e7d32', fontSize: '1.05rem'}}>✓ {successMessage}</div>
            <small style={{color: '#666', marginTop: '10px', display: 'block'}}>Redirection en cours...</small>
          </div>
        )}

        {/* Barre de progression */}
        <div
          className="progress-bar-container"
          style={{
            "--progress": currentStep === STEPS.length ? '100%' : `${(currentStep / STEPS.length) * 100}%`
          }}
        >
          {STEPS.map((s, idx) => (
            <div key={idx} className={`progress-step ${idx === currentStep ? 'active' : ''} ${idx < currentStep ? 'completed' : ''}`}>
              <div className={`progress-step-circle ${idx === currentStep ? 'active' : ''} ${idx < currentStep ? 'completed' : ''}`} aria-hidden="false">
                {idx + 1}
              </div>
              <div className="progress-step-label" title={s.label} aria-label={s.label} style={{fontSize: '1.1rem'}}>{getStepIcon(s.key)}</div>
            </div>
          ))}
        </div>

        {/* Contenu des étapes */}
        {currentStep < STEPS.length ? (
          <form onSubmit={(e) => { e.preventDefault(); handleNext(); }} className="step-card">
            <div style={{marginBottom: '24px'}}>
              <h3 style={{fontSize: '1.2rem', marginBottom: '16px', color: 'var(--text)'}}>
                {STEPS[currentStep].question}
              </h3>
              {renderStepContent()}
            </div>

            <div className="button-group">
              <button
                type="button"
                className="btn-nav"
                onClick={handlePrevious}
                disabled={currentStep === 0}
              >
                ← Retour
              </button>
              <button
                type="submit"
                className="btn-nav btn-next"
              >
                {currentStep === STEPS.length - 1 ? 'Récapitulatif →' : 'Continuer →'}
              </button>
            </div>
          </form>
        ) : (
          <div className="step-card">
            {renderSummary()}

            <div className="button-group">
              <button
                type="button"
                className="btn-nav"
                onClick={() => setCurrentStep(STEPS.length - 1)}
              >
                ← Retour
              </button>
              <button
                type="submit"
                className="btn-nav btn-next"
                disabled={loading}
                onClick={handleSubmit}
              >
                {loading ? '⏳ Inscription...' : '✓ S\'inscrire'}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
